import evEnums from "@/enums";
import type { ProcessPersonStatusType, ProcessStatusType } from "@/enums/types";
import type { Process } from "@/repositories/process/types";

const getOpenProcesses = (processes: Process[]) => {
  if (!processes?.length) {
    return [];
  }
  const processStatusEnum = evEnums.PROCESS.ProcessStatus;
  const statusToShow: ProcessStatusType[] = [processStatusEnum.LAUNCHED.Name];
  const processPersonStatusEnum = evEnums.PROCESS.ProcessPersonStatus;
  const processPersonStatusToShow: ProcessPersonStatusType[] = [
    processPersonStatusEnum.OPEN.Name,
    processPersonStatusEnum.INPROGRESS.Name,
  ];
  const filteredProcesses = processes.filter(({ status, processPersonStatus }) => {
    const isStatusAvailable = statusToShow.includes(status.Name);
    const isProcessPersonStatusAvailable = processPersonStatusToShow.includes(
      processPersonStatus.Name
    );
    return isStatusAvailable && isProcessPersonStatusAvailable;
  });
  return filteredProcesses;
};

export default getOpenProcesses;
